import axios from 'axios'
import { POS_ONLINE_HEADER } from '@/utils/static'

/**
 * Endpoint antrean transaksi async POS (Mode Zero-Loading).
 * - POST /pos/asyncOperations: kirim batch (max 100 op), idempoten per op_id.
 * - GET  /pos/asyncOperations?batch_id=: rekonsiliasi (local_id → trans_id + error).
 * - GET  /pos/asyncOperations/failed: op Failed/Blocked (lintas batch) yang perlu tindakan.
 * - POST /pos/asyncOperations/{opId}/resolve: selesaikan op yang gagal di BE.
 * Request latar belakang: tanpa toast error global & tanpa modal "tidak ada internet"
 * (pesan error disimpan ke op & tampil di Riwayat Sinkronisasi).
 */
const BACKGROUND_CONFIG = {
  ...POS_ONLINE_HEADER,
  skipErrorNotification: true,
  silentOffline: true,
}

/** @param {{device_id: string, user_id: number, operations: object[]}} body */
export const enqueueAsyncOperations = (body) => {
  return axios.post('/pos/asyncOperations', body, BACKGROUND_CONFIG)
}

export const getAsyncOperationsStatus = (batchId) => {
  return axios.get('/pos/asyncOperations', { params: { batch_id: batchId }, ...BACKGROUND_CONFIG })
}

/**
 * @param {{device_id: string, include_history?: 0|1, page?: number, per_page?: number}} params
 */
export const getFailedAsyncOperations = (params) => {
  return axios.get('/pos/asyncOperations/failed', { params, ...BACKGROUND_CONFIG })
}

/**
 * @param {string} opId
 * @param {{action: 'retry_as_is'|'correct_payload'|'shift_trans_date'|'create_product'|'create_contact'|'move_shift'|'bypass_shift_closed'|'discard', resolution_payload?: object, note?: string}} body
 */
export const resolveAsyncOperation = (opId, body) => {
  return axios.post(`/pos/asyncOperations/${opId}/resolve`, body, BACKGROUND_CONFIG)
}
